import { useState } from "react";

const hotWords = ["奇幻异能", "悬疑推理", "恋爱甜宠", "末世生存", "科幻脑洞"];

interface HeroProps {
  onSearch: (keyword: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const [keyword, setKeyword] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(keyword);
    document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
  };

  const quick = (w: string) => {
    setKeyword(w);
    onSearch(w);
    document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative min-h-[88vh] flex items-center overflow-hidden">
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20dark%20dramatic%20collage%20of%20Korean%20webtoon%20characters%20in%20a%20futuristic%20neon%20city%20skyline%20at%20night%2C%20mysterious%20heroes%20and%20heroines%20silhouettes%20surrounded%20by%20glowing%20warm%20coral%20orange%20and%20gold%20lighting%2C%20cinematic%20anime%20background%20art%2C%20vibrant%20action%20energy%2C%20rich%20atmospheric%20depth%2C%20no%20text&width=1600&height=900&seq=hero-2026-manchao&orientation=landscape"
          alt="韩国动态漫画精选榜首屏背景图"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-background-50"></div>
      </div>

      {/* content */}
      <div className="relative z-10 w-full mx-auto max-w-7xl px-4 md:px-6 pt-28 md:pt-32 pb-16 md:pb-20 text-center">
        <div className="flex flex-col items-center gap-5 md:gap-7">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-white/90 text-xs md:text-sm font-semibold backdrop-blur-sm">
            <i className="ri-fire-line text-accent-400"></i>
            韩国动态漫画 · 人气榜单每周实时更新
            <i className="ri-sparkling-2-line text-accent-400"></i>
          </span>

          <h1 className="text-3xl md:text-6xl font-black text-white leading-tight max-w-4xl">
            热门<span className="font-display text-accent-400">韩漫</span>精选，
            <br className="hidden md:block" />
            高口碑作品<span className="text-primary-400">一网打尽</span>
          </h1>

          <p className="text-sm md:text-lg text-white/80 max-w-2xl leading-relaxed">
            韩国动态漫画推荐与排行，人气榜单实时更新。精选热门高口碑作品，帮你快速锁定心仪动态漫画，追更不迷路。
          </p>

          {/* search */}
          <form
            onSubmit={submit}
            className="w-full max-w-xl flex flex-col sm:flex-row gap-2.5 sm:items-center bg-white rounded-full p-1.5 sm:p-2 shadow-lg"
          >
            <div className="flex items-center gap-2 flex-1 px-3 sm:px-4">
              <i className="ri-search-line text-foreground-400 text-lg"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索你想看的韩漫，如：悬疑 / 恋爱 / 末世…"
                className="w-full bg-transparent outline-none text-sm md:text-base text-foreground-900 placeholder:text-foreground-400 py-2.5"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              开始搜索
            </button>
          </form>

          {/* hot words */}
          <div className="flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-white/60">热门搜索：</span>
            {hotWords.map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => quick(w)}
                className="px-3 py-1.5 rounded-full bg-white/10 border border-white/15 text-white/85 text-xs cursor-pointer hover:bg-accent-500 hover:text-foreground-950 hover:border-accent-500 transition-colors"
              >
                {w}
              </button>
            ))}
          </div>

          {/* stats */}
          <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-6 w-full max-w-3xl">
            {[
              { num: "240+", label: "精选作品" },
              { num: "7", label: "题材分类" },
              { num: "30+", label: "每周更新" },
              { num: "96%", label: "读者好评" },
            ].map((s) => (
              <div
                key={s.label}
                className="px-4 py-4 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm"
              >
                <div className="text-2xl md:text-3xl font-black text-accent-400">{s.num}</div>
                <div className="text-xs md:text-sm text-white/70 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}